import { render, staticRenderFns } from "./NotasImportadas.vue?vue&type=template&id=7a7ae0b3&scoped=true"
import script from "./NotasImportadas.vue?vue&type=script&lang=js"
export * from "./NotasImportadas.vue?vue&type=script&lang=js"
import style0 from "./NotasImportadas.vue?vue&type=style&index=0&id=7a7ae0b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7ae0b3",
  null
  
)

export default component.exports